import React from "react"
import Header4 from "./../Common/Header4"
// import Footer from "./../Common/Footer"
import Banner from "./../Elements/Banner"
// import About2 from "./../Elements/About2"
// import WhatWeDo6 from "./../Elements/WhatWeDo6"
// import Achievements1 from "./../Elements/Achievements1"
// import Team2 from "./../Elements/Team2"
import Testimonials2 from "./../Elements/Testimonials2"
// import SimilarProjects from "../Elements/SimilarProjects"
import Footer2 from "../Common/Footer2"

var bnrimg = require("./../../images/banner/1.jpg")

class Contact1 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script")
        script.src = src
        script.addEventListener("load", function () {
          resolve()
        })
        script.addEventListener("error", function (e) {
          reject(e)
        })
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
    }

    loadScript("./assets/js/custom.js")
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner
            title="Askala Company"
            pagename="Contact Us"
            description="You can rely on us for dependable products and services that enhance your home while supporting sustainable practices." // "The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized."
            bgimage={bnrimg}
          />
          {/* <About2 /> */}
          {/* <Achievements1 /> */}
          {/* <SimilarProjects
            alignment="separator-center"
            title="Government Approval"
          /> */}
          {/* <WhatWeDo6 /> */}

          {/* <Team2 /> */}
          <Testimonials2 separatoralignment="separator-center" />
          <section className="wpo-contact-map-section">
        <h2 className="hidden">Contact map</h2>
        <div className="wpo-contact-map">
          
          <iframe
            title="Arbat, Sulaymaniyah Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13004.688045179446!2d45.563370835409536!3d35.425768738672495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fff828e515fd315%3A0xe19e61c6f93b1de0!2sArbat%2C%20Sulaymaniyah%20Governorate!5e0!3m2!1sen!2siq!4v1748515249952!5m2!1sen!2siq"
            allowFullScreen
          ></iframe>
        </div>
      </section>
        </div>

        <Footer2 />
      </>
    )
  }
}

export default Contact1
